import React from 'react'
import classNames from 'classnames'
import Field from '../Field'

const InputElement = ({ innerRef, errors, className, ...props }) => (
  <input
    className={classNames(className, [
      'w-full',
      'transition',
      'duration-200',
      'border',
      'peer',
    ], {
      xs:   'p-1',
      sm:   'p-1 sm:p-2',
      base: 'p-1 sm:p-2 md:p-4',
      lg:   'p-1 sm:p-2 md:p-4 lg:p-6',
    }[props.size] ?? 'p-4', {
      'border-gray-300 focus:border-primary': !errors.length,
      'border-negative': !!errors.length,
    })}
    ref={innerRef}
    {...props}
  />
)

export const Input = (props) => (
  <Field {...props} element={InputElement} />
)

export default Input
